import React, {Component} from 'react';
// import './Contato.css';

export default class Contato extends Component {
    render() {
        return (
            <div className="content">
                <h1 className="titulo">Contato</h1>
                
                <strong>Telefone:</strong> +55 (11) 5095-1609<br />
                <strong>FAX:</strong> +55 (11) 5095-3499<br />
                <strong>E-mail:</strong> <a href="mailto:adrf@adrfbusiness.com.br">adrf@adrfbusiness.com.br</a><br />
                <strong>Endereço:</strong><br />
                Av. Dr. Chucri Zaidan, 296, conj. 231<br />
                São Paulo - SP. Vl. Cordeiro. CEP 04583-110, Brazil.<br />
                <br />
                <h2 className="titulo">Como chegar</h2>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3655.499967358988!2d-46.70180068452479!3d-23.622259569730204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce50db34acee0b%3A0x850bd1d901d0924c!2sAv.+Dr.+Chucri+Zaidan%2C+940+-+Ch%C3%A1cara+Santo+Ant%C3%B4nio+(Zona+Sul)%2C+S%C3%A3o+Paulo+-+SP%2C+04707-120!5e0!3m2!1sen!2sbr!4v1534170284134" width="100%" height="450" frameBorder="0" allowfullscreen></iframe>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Contato.js